import { render } from "./ThePageTitle.vue?vue&type=template&id=7d7c1148"
const script = {}

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__